// import { Fragment, useState, useEffect } from 'react';
// import hLogo from './../../images/dl-h-logo.png';
// import { Popover, Transition, Menu } from '@headlessui/react';
// import { MenuIcon, XIcon, BellIcon } from '@heroicons/react/outline';
// import { NotificationForDoctor, NotificationForPatient } from '../../v2/services/notification';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import RedAlert from '../../common/components/redAlert/RedAlert';
// import Configurations from '../../common/utils/configurations';
// import { useInfoStore } from '../../App';
// import { handleImageError } from '../../common/helpers/helper';
// import useNotificationStore from '../../zustand/notification';
// import { deleteDoctorAccount, deletePatientAccount } from '../../api/deleteAccount';
// import DeleteConfirmationModal from '../../common/components/deleteConfirmationModal/DeleteConfirmationModal';

// function classNames(...classes) {
//     return classes.filter(Boolean).join(' ');
// }

// const APP_SERVER = process.env.REACT_APP_API_SERVER;

// export default function Header(props) {
//     console.log('hello');
//     const { setCount, count } = useNotificationStore();

//     const { highlight } = props;
//     const { userInfo: user } = useInfoStore((state) => state);

//     const navigate = useNavigate();
//     const { pathname } = useLocation();
//     const [openSignOutModal, setOpenSignOutModal] = useState(false);
//     const [openDeleteAccountModal, setOpenDeleteAccountModal] = useState(false);
//     const [notifications, setNotifications] = useState([]);
//     const [notificationCount, setNotificationCount] = useState(null);
//     const [deleteAccountError, setDeleteAccountError] = useState(null);
//     const [showNotifications, setShowNotifications] = useState(false);

//     const fetchNotifications = async () => {
//         if (!user) return;

//         try {
//             const res =
//                 user.usertype === 1
//                     ? await NotificationForPatient.patientNotificationList()
//                     : await NotificationForDoctor.doctorNotificationList();

//             setNotifications(res.data.data || []);
//             setNotificationCount(res.data.unreadCount || 0);
//         } catch (error) {
//             console.error('Error fetching notifications:', error);
//         }
//     };

//     // here for count api
//     useEffect(() => {
//         if (!user) return;

//         const fetchNotificationCount = async () => {
//             const res =
//                 user.usertype === 1
//                     ? await NotificationForPatient.doctorNotificationCount()
//                     : await NotificationForDoctor.doctorNotificationCount();

//             setNotificationCount(res.data.unreadCount);
//         };
//         fetchNotificationCount();
//     }, [user]);

//     const _confirmLogout = () => {
//         setOpenSignOutModal(false);
//         const userType = user?.usertype === 1 ? 'patient' : 'doctor';
//         navigate('/session-expired', { state: { userType } });
//     };

//     const _confirmSignOutCancel = () => {
//         setOpenSignOutModal(false);
//     };

//     const _confirmDeleteAccount = () => {
//         setOpenDeleteAccountModal(false);
//         const userType = user?.usertype === 1 ? 'patient' : 'doctor';
//         navigate('/session-expired', { state: { userType } });
//     };

//     const _confirmDeleteAccountCancel = () => {
//         setOpenDeleteAccountModal(false);
//     };

//     const handleDeleteAccount = async () => {
//         if (!user?.id) {
//             setDeleteAccountError('No se pudo obtener la información del usuario.');
//             return;
//         }

//         try {
//             setDeleteAccountError(null);

//             let result;
//             if (user.usertype === 1) {
//                 // Patient account
//                 result = await deletePatientAccount(user.id, setDeleteAccountError);
//             } else if (user.usertype === 2) {
//                 // Doctor account
//                 result = await deleteDoctorAccount(user.id, setDeleteAccountError);
//             } else {
//                 setDeleteAccountError('Tipo de usuario no válido.');
//                 return;
//             }

//             // Check if the result indicates an error
//             if (result === undefined || result.status >= 400) {
//                 console.error('Delete account failed with result:', result);
//                 setDeleteAccountError('Error al eliminar la cuenta. Inténtelo de nuevo.');
//                 return;
//             }

//             // If successful, redirect to logout
//             _confirmDeleteAccount();
//         } catch (error) {
//             console.error('Delete account failed:', error);
//             setDeleteAccountError('Error al eliminar la cuenta. Inténtelo de nuevo.');
//         }
//     };

//     return (
//         <Popover className="relative">
//             <div className="absolute inset-0 pointer-events-none header-box-top" aria-hidden="true" />
//             <div className="relative z-31">
//                 <div
//                     className={classNames(
//                         pathname === '/' ? 'bg-transparent' : 'bg-white',
//                         'header mx-auto flex justify-between items-center px-4 py-5 sm:px-6 sm:py-4 lg:px-8 xl:justify-start md:space-x-10 '
//                     )}
//                 >
//                     <div>
//                         <Link to="/" className="flex">
//                             <span className="sr-only">DoctoLink</span>
//                             <img className="h-8 w-auto sm:h-10" src={hLogo} alt="" />
//                         </Link>
//                     </div>
//                     <div className="-mr-2 -my-2 xl:hidden">
//                         <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-dl-primary-900">
//                             <span className="sr-only">Abrir menú</span>
//                             <MenuIcon className="h-6 w-6" aria-hidden="true" />
//                         </Popover.Button>
//                     </div>
//                     <div className="hidden xl:flex-1 xl:flex xl:items-center xl:justify-between">
//                         <Popover.Group as="nav" className="flex space-x-10 navlink-list">
//                             {/* <Link href="#" className={classNames(highlight === 'Home' ? 'text-blue-600' : '', 'text-base font-medium text-gray-500 hover:text-dl-accent')} to={'/'}>
//                 Inicio
//               </Link> */}
//                             <Link
//                                 className={classNames(
//                                     highlight === 'WhatIsDoctolink' ? 'text-blue-600' : '',
//                                     'text-base font-medium text-gray-500 hover:text-dl-accent'
//                                 )}
//                                 to={'/what-is-doctolink'}
//                             >
//                                 ¿Qué es Doctolink?
//                             </Link>
//                             <Link
//                                 href="#"
//                                 className={classNames(
//                                     highlight === 'WhoWeAre' ? 'text-blue-600' : '',
//                                     'text-base font-medium text-gray-500 hover:text-dl-accent'
//                                 )}
//                                 to={'/who-we-are'}
//                             >
//                                 ¿Quiénes somos?
//                             </Link>
//                             <Link
//                                 href="#"
//                                 className={classNames(
//                                     highlight === 'WhoWeAre' ? 'text-blue-600' : '',
//                                     'text-base font-medium text-gray-500 hover:text-dl-accent'
//                                 )}
//                                 to={'/blog'}
//                             >
//                                 Blog
//                             </Link>
//                             <Link
//                                 href="#"
//                                 className={classNames(
//                                     highlight === 'WhoWeAre' ? 'text-blue-600' : '',
//                                     'text-base font-medium text-gray-500 hover:text-dl-accent'
//                                 )}
//                                 to={'/plans'}
//                             >
//                                 Planes
//                             </Link>
//                         </Popover.Group>
//                         {/*  ADD INSIDE NOTIFICATION BELL */}

//                         {user && (
//                             <div>
//                                 {/*  i wan to right this icon
//                                  */}
//                             </div>
//                         )}
//                         {!user && (
//                             <div className="flex items-center md:ml-12">
//                                 <Link
//                                     to={'/contact-us'}
//                                     className={classNames(
//                                         highlight === 'SignIn' ? 'text-blue-600' : '',
//                                         'text-base font-medium text-gray-500 hover:text-dl-accent'
//                                     )}
//                                 >
//                                     Contactanos
//                                 </Link>
//                                 {/* Profile dropdown */}
//                                 <Menu as="div" className="relative ml-3">
//                                     <div>
//                                         <Menu.Button
//                                             className={classNames(
//                                                 highlight === 'SignIn' ? 'text-blue-600' : '',
//                                                 'text-base font-medium text-gray-500 hover:text-dl-accent'
//                                             )}
//                                         >
//                                             Iniciar sesión
//                                         </Menu.Button>
//                                     </div>
//                                     <Transition
//                                         as={Fragment}
//                                         enter="transition ease-out duration-200"
//                                         enterFrom="transform opacity-0 scale-95"
//                                         enterTo="transform opacity-100 scale-100"
//                                         leave="transition ease-in duration-75"
//                                         leaveFrom="transform opacity-100 scale-100"
//                                         leaveTo="transform opacity-0 scale-95"
//                                     >
//                                         <Menu.Items className="absolute right-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
//                                             <Menu.Item>
//                                                 {({ active }) => (
//                                                     <Link
//                                                         to="/sign-in"
//                                                         className={classNames(
//                                                             active ? 'bg-gray-100' : '',
//                                                             'block px-4 py-2 text-sm text-gray-700'
//                                                         )}
//                                                     >
//                                                         Soy Paciente
//                                                     </Link>
//                                                 )}
//                                             </Menu.Item>
//                                             <Menu.Item>
//                                                 {({ active }) => (
//                                                     <Link
//                                                         to="/sign-in-doctor"
//                                                         className={classNames(
//                                                             active ? 'bg-gray-100' : '',
//                                                             'block px-4 py-2 text-sm text-gray-700'
//                                                         )}
//                                                     >
//                                                         Soy Doctor
//                                                     </Link>
//                                                 )}
//                                             </Menu.Item>
//                                         </Menu.Items>
//                                     </Transition>
//                                 </Menu>
//                                 {/* <Link to="/sign-up" className="ml-8 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700">
//                   Registro
//                 </Link> */}

//                                 <Menu as="div" className="relative ml-3">
//                                     <div>
//                                         <Menu.Button className="ml-8 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700">
//                                             Registrarse
//                                         </Menu.Button>
//                                     </div>
//                                     <Transition
//                                         as={Fragment}
//                                         enter="transition ease-out duration-200"
//                                         enterFrom="transform opacity-0 scale-95"
//                                         enterTo="transform opacity-100 scale-100"
//                                         leave="transition ease-in duration-75"
//                                         leaveFrom="transform opacity-100 scale-100"
//                                         leaveTo="transform opacity-0 scale-95"
//                                     >
//                                         <Menu.Items className="absolute right-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
//                                             <Menu.Item>
//                                                 {({ active }) => (
//                                                     <Link
//                                                         to="/sign-up"
//                                                         className={classNames(
//                                                             active ? 'bg-gray-100' : '',
//                                                             'block px-4 py-2 text-sm text-gray-700'
//                                                         )}
//                                                     >
//                                                         Soy Paciente
//                                                     </Link>
//                                                 )}
//                                             </Menu.Item>
//                                             <Menu.Item>
//                                                 {({ active }) => (
//                                                     <Link
//                                                         to="/sign-up-doctor"
//                                                         className={classNames(
//                                                             active ? 'bg-gray-100' : '',
//                                                             'block px-4 py-2 text-sm text-gray-700'
//                                                         )}
//                                                     >
//                                                         Soy Doctor
//                                                     </Link>
//                                                 )}
//                                             </Menu.Item>
//                                         </Menu.Items>
//                                     </Transition>
//                                 </Menu>
//                             </div>
//                         )}

//                         {user && (
//                             <div className="cursor-pointer flex items-center md:ml-12">
//                                 {/* Profile dropdown */}
//                                 <Menu as="div" className="relative flex-shrink-0">
//                                     <Menu.Button
//                                         className="relative flex items-center hover:bg-gray-100 p-1 rounded-full"
//                                         onClick={fetchNotifications}
//                                     >
//                                         <Link to={'/notification'} style={{ color: 'inherit' }}>
//                                             <BellIcon className="h-7 w-7" />
//                                         </Link>

//                                         {notificationCount > 0 && (
//                                             <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
//                                                 {notificationCount}
//                                             </span>
//                                         )}
//                                     </Menu.Button>
//                                 </Menu>

//                                 <Menu as="div" className="ml-4 relative flex-shrink-0">
//                                     <div className=" ">
//                                         <div className="flex items-center documentos-citas-btn">
//                                             {/* documentos */}

//                                             {user?.usertype === 1 ? (
//                                                 <Link
//                                                     to={'/my-documents'}
//                                                     className={`mr-4 text-base font-bold drop-shadow-lg ${
//                                                         pathname === '/my-documents' ? 'documentos-btn' : 'citas-btn'
//                                                     }`}
//                                                 >
//                                                     Documentos
//                                                 </Link>
//                                             ) : null}
//                                             <Link
//                                                 to={
//                                                     String(user.usertype) === '2'
//                                                         ? '/appointment-manager-doctor'
//                                                         : '/appointment-manager'
//                                                 }
//                                                 className={`mr-4 text-base font-bold drop-shadow-lg ${
//                                                     pathname === '/appointment-manager' ||
//                                                     pathname === '/appointment-manager-doctor'
//                                                         ? 'documentos-btn'
//                                                         : 'citas-btn'
//                                                 }`}
//                                             >
//                                                 Citas
//                                             </Link>
//                                             <Menu.Button>
//                                                 <figure className="border-4 border-sky-400	rounded-full w-16 h-16">
//                                                     <img
//                                                         className="h-full w-full rounded-full "
//                                                         src={
//                                                             user?.personalImage
//                                                                 ? `${APP_SERVER}/${user?.personalImage}`
//                                                                 : Configurations?.defaultImage
//                                                         }
//                                                         alt=""
//                                                         onError={handleImageError}
//                                                     />
//                                                 </figure>
//                                             </Menu.Button>
//                                         </div>
//                                     </div>
//                                     <Transition
//                                         as={Fragment}
//                                         enter="transition ease-out duration-100"
//                                         enterFrom="transform opacity-0 scale-95"
//                                         enterTo="transform opacity-100 scale-100"
//                                         leave="transition ease-in duration-75"
//                                         leaveFrom="transform opacity-100 scale-100"
//                                         leaveTo="transform opacity-0 scale-95"
//                                     >
//                                         <Menu.Items className="z-40 origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
//                                             {String(user.usertype) === '2' && (
//                                                 <Menu.Item>
//                                                     {({ active }) => (
//                                                         <Link
//                                                             to="/doctor-profile"
//                                                             className={classNames(
//                                                                 active ? 'bg-gray-100' : '',
//                                                                 'block px-4 py-2 text-sm text-gray-700'
//                                                             )}
//                                                         >
//                                                             Perfil Doctor
//                                                         </Link>
//                                                     )}
//                                                 </Menu.Item>
//                                             )}
//                                             {String(user.usertype) === '2' && (
//                                                 <Menu.Item>
//                                                     {({ active }) => (
//                                                         <Link
//                                                             to="/appointment-manager-doctor"
//                                                             className={classNames(
//                                                                 active ? 'bg-gray-100' : '',
//                                                                 'block px-4 py-2 text-sm text-gray-700'
//                                                             )}
//                                                         >
//                                                             Citas
//                                                         </Link>
//                                                     )}
//                                                 </Menu.Item>
//                                             )}

//                                             {String(user.usertype) === '1' && (
//                                                 <Menu.Item>
//                                                     {({ active }) => (
//                                                         <Link
//                                                             to="/patient-profile"
//                                                             className={classNames(
//                                                                 active ? 'bg-gray-100' : '',
//                                                                 'block px-4 py-2 text-sm text-gray-700'
//                                                             )}
//                                                         >
//                                                             Perfil Paciente
//                                                         </Link>
//                                                     )}
//                                                 </Menu.Item>
//                                             )}
//                                             {String(user.usertype) === '1' && (
//                                                 <Menu.Item>
//                                                     {({ active }) => (
//                                                         <Link
//                                                             to="/appointment-manager"
//                                                             className={classNames(
//                                                                 active ? 'bg-gray-100' : '',
//                                                                 'block px-4 py-2 text-sm text-gray-700'
//                                                             )}
//                                                         >
//                                                             Citas
//                                                         </Link>
//                                                     )}
//                                                 </Menu.Item>
//                                             )}
//                                             <Menu.Item>
//                                                 {({ active }) => (
//                                                     <span
//                                                         onClick={() => setOpenDeleteAccountModal(true)}
//                                                         className={classNames(
//                                                             active ? 'bg-gray-100' : '',
//                                                             'block px-4 py-2 text-sm text-gray-700'
//                                                         )}
//                                                     >
//                                                         Eliminar cuenta
//                                                     </span>
//                                                 )}
//                                             </Menu.Item>
//                                             <Menu.Item>
//                                                 {({ active }) => (
//                                                     <span
//                                                         onClick={() => setOpenSignOutModal(true)}
//                                                         className={classNames(
//                                                             active ? 'bg-gray-100' : '',
//                                                             'block px-4 py-2 text-sm text-gray-700'
//                                                         )}
//                                                     >
//                                                         Cerrar sesión
//                                                     </span>
//                                                 )}
//                                             </Menu.Item>
//                                         </Menu.Items>
//                                     </Transition>
//                                 </Menu>
//                             </div>
//                         )}
//                         <RedAlert
//                             open={Boolean(openSignOutModal)}
//                             title={`Desea cerrar esta sesión?`}
//                             bodyText={'Si confirma esta diálogo entonces pasará a cerrar la sesión que tiene abierta.'}
//                             onConfirm={_confirmLogout}
//                             onCancel={_confirmSignOutCancel}
//                         />

//                         {/* Delete Account Confirmation Modal */}
//                         <DeleteConfirmationModal
//                             open={openDeleteAccountModal}
//                             onClose={_confirmDeleteAccountCancel}
//                             title="Eliminar cuenta"
//                             bodyText="¿Estás seguro de que quieres eliminar tu cuenta? Esta acción es irreversible y se perderán todos tus datos permanentemente."
//                             onConfirm={handleDeleteAccount}
//                             onCancel={_confirmDeleteAccountCancel}
//                         />

//                         {/* Delete Account Error Alert */}
//                         {deleteAccountError && (
//                             <RedAlert
//                                 open={Boolean(deleteAccountError)}
//                                 title="Error al eliminar cuenta"
//                                 bodyText={deleteAccountError}
//                                 onConfirm={() => setDeleteAccountError(null)}
//                                 onCancel={() => setDeleteAccountError(null)}
//                             />
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <Transition
//                 as={Fragment}
//                 enter="duration-200 ease-out"
//                 enterFrom="opacity-0 scale-95"
//                 enterTo="opacity-100 scale-100"
//                 leave="duration-100 ease-in"
//                 leaveFrom="opacity-100 scale-100"
//                 leaveTo="opacity-0 scale-95"
//             >
//                 <Popover.Panel
//                     focus
//                     className="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right xl:hidden"
//                 >
//                     <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
//                         <div className="pt-5 pb-6 px-5 sm:pb-8">
//                             <div className="flex items-center justify-between">
//                                 <div>
//                                     <img className="h-8 w-auto" src={hLogo} alt="DoctoLink" />
//                                 </div>
//                                 <div className="-mr-2">
//                                     <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-dl-primary-900">
//                                         <span className="sr-only">Cerrar menú</span>
//                                         <XIcon className="h-6 w-6" aria-hidden="true" />
//                                     </Popover.Button>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="py-6 px-5">
//                             <div className="grid grid-cols-2 gap-4">
//                                 {/* <Link className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent" to={'/'}>
//                   Inicio
//                 </Link> */}
//                                 <Link
//                                     className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                     to={'/what-is-doctolink'}
//                                 >
//                                     <Popover.Button> ¿Qué es Doctolink?</Popover.Button>
//                                 </Link>
//                                 <Link
//                                     className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                     to={'/who-we-are'}
//                                 >
//                                     <Popover.Button> ¿Quiénes somos?</Popover.Button>
//                                 </Link>
//                                 <Link
//                                     to="/contact-us"
//                                     className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                 >
//                                     <Popover.Button> Contacto </Popover.Button>
//                                 </Link>
//                                 <Link
//                                     to="/blog"
//                                     className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                 >
//                                     <Popover.Button> Blog </Popover.Button>
//                                 </Link>
//                                 <Link
//                                     to="/plans"
//                                     className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                 >
//                                     <Popover.Button> Planes </Popover.Button>
//                                 </Link>

//                                 {user && (
//                                     <>
//                                         {/* Profile dropdown */}

//                                         {String(user.usertype) === '2' && (
//                                             <Link
//                                                 to="/doctor-profile"
//                                                 className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                             >
//                                                 <Popover.Button> Perfil Doctor</Popover.Button>
//                                             </Link>
//                                         )}
//                                         {String(user.usertype) === '2' && (
//                                             <Link
//                                                 to="/appointment-manager-doctor"
//                                                 className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                             >
//                                                 <Popover.Button> Citas</Popover.Button>
//                                             </Link>
//                                         )}

//                                         {String(user.usertype) === '1' && (
//                                             <Link
//                                                 to="/patient-profile"
//                                                 className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                             >
//                                                 <Popover.Button> Perfil Paciente </Popover.Button>
//                                             </Link>
//                                         )}
//                                         {String(user.usertype) === '1' && (
//                                             <Link
//                                                 to="/appointment-manager"
//                                                 className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
//                                             >
//                                                 <Popover.Button> Citas </Popover.Button>
//                                             </Link>
//                                         )}
//                                         <span
//                                             onClick={() => setOpenSignOutModal(true)}
//                                             className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent cursor-pointer"
//                                         >
//                                             Cerrar sesión
//                                         </span>
//                                     </>
//                                 )}
//                             </div>

//                             {!user && (
//                                 <div className="mt-6 flex flex-col gap-4">
//                                     <Link
//                                         to={'/sign-up'}
//                                         className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700"
//                                     >
//                                         <Popover.Button>Registro Paciente</Popover.Button>
//                                     </Link>
//                                     <Link
//                                         to={'/sign-up-doctor'}
//                                         className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700"
//                                     >
//                                         <Popover.Button>Registro Doctor</Popover.Button>
//                                     </Link>
//                                     <div className="flex flex-col gap-8 mt-6 text-center text-base font-medium text-dl-accent">
//                                         &iquest;Ya tienes cuenta de DoctoLink?{' '}
//                                         <Link className="text-dl-primary-900 hover:text-dl-primary-700" to="/sign-in">
//                                             <Popover.Button>Iniciar sesión como paciente</Popover.Button>
//                                         </Link>
//                                         <Link
//                                             className="text-dl-primary-900 hover:text-dl-primary-700"
//                                             to="/sign-in-doctor"
//                                         >
//                                             <Popover.Button> Iniciar sesión como doctor</Popover.Button>
//                                         </Link>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </Popover.Panel>
//             </Transition>
//         </Popover>
//     );
// }


import { Fragment, useState, useEffect } from 'react';
import hLogo from './../../images/dl-h-logo.png';
import { Popover, Transition, Menu } from '@headlessui/react';
import { MenuIcon, XIcon, BellIcon } from '@heroicons/react/outline';
import { NotificationForDoctor, NotificationForPatient } from '../../v2/services/notification';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import RedAlert from '../../common/components/redAlert/RedAlert';
import Configurations from '../../common/utils/configurations';
import { useInfoStore } from '../../App';
import { handleImageError } from '../../common/helpers/helper';
import { useSelector, useDispatch } from 'react-redux';
import { setCount, resetCount } from '../../redux/slices/notificationSlice';
import { deleteDoctorAccount, deletePatientAccount } from '../../api/deleteAccount';
import DeleteConfirmationModal from '../../common/components/deleteConfirmationModal/DeleteConfirmationModal';
import useUserStore from '../../zustand/fcmToken';
import { DoctorProfile } from '../../v2/services/DoctorProfile';
import { PublicProfileS } from '../../v2/services/ProfilePublic';
function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const APP_SERVER = process.env.REACT_APP_API_SERVER;

export default function Header(props) {
    const dispatch = useDispatch();
    const count = useSelector((state) => state.notification.count);

    const { highlight, onSignOut } = props;
    const { userInfo: user, setUserInfo } = useInfoStore((state) => state);
    const fcmToken = useUserStore((state) => state.fcmToken);

    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [openSignOutModal, setOpenSignOutModal] = useState(false);
    const [openDeleteAccountModal, setOpenDeleteAccountModal] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState(null);
    const [deleteAccountError, setDeleteAccountError] = useState(null);
    const [showNotifications, setShowNotifications] = useState(false);

    // const fetchNotifications = async () => {
    //     if (!user) return;

    //     try {
    //         const res =
    //             user.usertype === 1
    //                 ? await NotificationForPatient.patientNotificationList()
    //                 : await NotificationForDoctor.doctorNotificationList();

    //         setNotifications(res.data.data || []);
    //         setNotificationCount(res.data.unreadCount || 0);
    //     } catch (error) {
    //         console.error('Error fetching notifications:', error);
    //     }
    // };

    // here for count api
    useEffect(() => {
        if (!user) return;

        const fetchNotificationCount = async () => {
            const res =
                user.usertype === 1
                    ? await NotificationForPatient.patientNotificationCount()
                    : await NotificationForDoctor.doctorNotificationCount();

            const unreadCount = res.data.unreadCount || 0;
            console.log('unreadCount', unreadCount);
            dispatch(setCount(unreadCount));
            setNotificationCount(unreadCount);
        };
        fetchNotificationCount();
    }, [user, dispatch]);

    // const _confirmLogout = () => {
    //     setOpenSignOutModal(false);
    //     const userType = user?.usertype === 1 ? 'patient' : 'doctor';
    //     navigate('/session-expired', { state: { userType } });
    // };

    const _confirmLogout = async () => {
        setOpenSignOutModal(false);

        const userType = user?.usertype === 1 ? 'patient' : 'doctor';
        const path = userType === 'patient' ? '/sign-in' : '/sign-in-doctor';

        try {
            const payload = { fcmToken: fcmToken };
            if (userType === 'doctor') {
                await DoctorProfile.logout(payload);
            } else {
                await PublicProfileS.logout(payload);
            }
        } catch (error) {
            console.error('Logout failed:', error);
        } finally {
            await onSignOut?.();
            setUserInfo(null);
            dispatch(resetCount());
            navigate(path, { replace: true });
        }
    };

    const _confirmSignOutCancel = () => {
        setOpenSignOutModal(false);
    };

    const _confirmDeleteAccount = () => {
        setOpenDeleteAccountModal(false);
        const userType = user?.usertype === 1 ? 'patient' : 'doctor';
        navigate('/session-expired', { state: { userType } });
    };

    const _confirmDeleteAccountCancel = () => {
        setOpenDeleteAccountModal(false);
    };

    const handleDeleteAccount = async () => {
        if (!user?.id) {
            setDeleteAccountError('No se pudo obtener la información del usuario.');
            return;
        }

        try {
            setDeleteAccountError(null);

            let result;
            if (user.usertype === 1) {
                // Patient account
                result = await deletePatientAccount(user.id, setDeleteAccountError);
            } else if (user.usertype === 2) {
                // Doctor account
                result = await deleteDoctorAccount(user.id, setDeleteAccountError);
            } else {
                setDeleteAccountError('Tipo de usuario no válido.');
                return;
            }

            // Check if the result indicates an error
            if (result === undefined || result.status >= 400) {
                console.error('Delete account failed with result:', result);
                setDeleteAccountError('Error al eliminar la cuenta. Inténtelo de nuevo.');
                return;
            }

            // If successful, redirect to logout
            _confirmDeleteAccount();
        } catch (error) {
            console.error('Delete account failed:', error);
            setDeleteAccountError('Error al eliminar la cuenta. Inténtelo de nuevo.');
        }
    };

    return (
        <Popover className="relative">
            <div className="absolute inset-0 pointer-events-none header-box-top" aria-hidden="true" />
            <div className="relative z-31">
                <div
                    className={classNames(
                        pathname === '/' ? 'bg-transparent' : 'bg-white',
                        'header mx-auto flex justify-between items-center px-4 py-5 sm:px-6 sm:py-4 lg:px-8 xl:justify-start md:space-x-10 '
                    )}
                >
                    <div>
                        <Link to="/" className="flex">
                            <span className="sr-only">DoctoLink</span>
                            <img className="h-8 w-auto sm:h-10" src={hLogo} alt="" />
                        </Link>
                    </div>
                    <div className="-mr-2 -my-2 xl:hidden">
                        <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-dl-primary-900">
                            <span className="sr-only">Abrir menú</span>
                            <MenuIcon className="h-6 w-6" aria-hidden="true" />
                        </Popover.Button>
                    </div>
                    <div className="hidden xl:flex-1 xl:flex xl:items-center xl:justify-between">
                        <Popover.Group as="nav" className="flex space-x-10 navlink-list">
                            {/* <Link href="#" className={classNames(highlight === 'Home' ? 'text-blue-600' : '', 'text-base font-medium text-gray-500 hover:text-dl-accent')} to={'/'}>
                Inicio
              </Link> */}
                            <Link
                                className={classNames(
                                    highlight === 'WhatIsDoctolink' ? 'text-blue-600' : '',
                                    'text-base font-medium text-gray-500 hover:text-dl-accent'
                                )}
                                to={'/what-is-doctolink'}
                            >
                                ¿Qué es Doctolink?
                            </Link>
                            <Link
                                href="#"
                                className={classNames(
                                    highlight === 'WhoWeAre' ? 'text-blue-600' : '',
                                    'text-base font-medium text-gray-500 hover:text-dl-accent'
                                )}
                                to={'/who-we-are'}
                            >
                                ¿Quiénes somos?
                            </Link>
                            <Link
                                href="#"
                                className={classNames(
                                    highlight === 'WhoWeAre' ? 'text-blue-600' : '',
                                    'text-base font-medium text-gray-500 hover:text-dl-accent'
                                )}
                                to={'/blog'}
                            >
                                Blog
                            </Link>
                            {/* <Link
                                href="#"
                                className={classNames(
                                    highlight === 'WhoWeAre' ? 'text-blue-600' : '',
                                    'text-base font-medium text-gray-500 hover:text-dl-accent'
                                )}
                                to={'/plans'}
                            >
                                Planes
                            </Link> */}
                        </Popover.Group>
                        {/*  ADD INSIDE NOTIFICATION BELL */}

                        {user && (
                            <div>
                                {/*  i wan to right this icon
                                 */}
                            </div>
                        )}
                        {!user && (
                            <div className="flex items-center md:ml-12">
                                <Link
                                    to={'/contact-us'}
                                    className={classNames(
                                        highlight === 'SignIn' ? 'text-blue-600' : '',
                                        'text-base font-medium text-gray-500 hover:text-dl-accent'
                                    )}
                                >
                                    Contactanos
                                </Link>
                                {/* Profile dropdown */}
                                <Menu as="div" className="relative ml-3">
                                    <div>
                                        <Menu.Button
                                            className={classNames(
                                                highlight === 'SignIn' ? 'text-blue-600' : '',
                                                'text-base font-medium text-gray-500 hover:text-dl-accent'
                                            )}
                                        >
                                            Iniciar sesión
                                        </Menu.Button>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-200"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items className="absolute right-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <Link
                                                        to="/sign-in"
                                                        className={classNames(
                                                            active ? 'bg-gray-100' : '',
                                                            'block px-4 py-2 text-sm text-gray-700'
                                                        )}
                                                    >
                                                        Soy Paciente
                                                    </Link>
                                                )}
                                            </Menu.Item>
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <Link
                                                        to="/sign-in-doctor"
                                                        className={classNames(
                                                            active ? 'bg-gray-100' : '',
                                                            'block px-4 py-2 text-sm text-gray-700'
                                                        )}
                                                    >
                                                        Soy Doctor
                                                    </Link>
                                                )}
                                            </Menu.Item>
                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                                {/* <Link to="/sign-up" className="ml-8 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700">
                  Registro
                </Link> */}

                                <Menu as="div" className="relative ml-3">
                                    <div>
                                        <Menu.Button className="ml-8 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700">
                                            Registrarse
                                        </Menu.Button>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-200"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items className="absolute right-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <Link
                                                        to="/sign-up"
                                                        className={classNames(
                                                            active ? 'bg-gray-100' : '',
                                                            'block px-4 py-2 text-sm text-gray-700'
                                                        )}
                                                    >
                                                        Soy Paciente
                                                    </Link>
                                                )}
                                            </Menu.Item>
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <Link
                                                        to="/sign-up-doctor"
                                                        className={classNames(
                                                            active ? 'bg-gray-100' : '',
                                                            'block px-4 py-2 text-sm text-gray-700'
                                                        )}
                                                    >
                                                        Soy Doctor
                                                    </Link>
                                                )}
                                            </Menu.Item>
                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                            </div>
                        )}

                        {user && (
                            <div className="cursor-pointer flex items-center md:ml-12">
                                {/* Profile dropdown */}
                                <Menu as="div" className="relative flex-shrink-0">
                                    <Menu.Button
                                        className="relative flex items-center hover:bg-gray-100 p-1 rounded-full"
                                        onClick={() => {
                                            dispatch(resetCount());
                                            navigate('/notification');
                                        }}
                                    >
                                        <BellIcon className="h-7 w-7" />

                                        {count > 0 && (
                                            <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                                                {count}
                                            </span>
                                        )}
                                    </Menu.Button>
                                </Menu>

                                <Menu as="div" className="ml-4 relative flex-shrink-0">
                                    <div className=" ">
                                        <div className="flex items-center documentos-citas-btn">
                                            {/* documentos */}

                                            {user?.usertype === 1 ? (
                                                <Link
                                                    to={'/my-documents'}
                                                    className={`mr-4 text-base font-bold drop-shadow-lg ${
                                                        pathname === '/my-documents' ? 'documentos-btn' : 'citas-btn'
                                                    }`}
                                                >
                                                    Documentos
                                                </Link>
                                            ) : null}
                                            <Link
                                                to={
                                                    String(user.usertype) === '2'
                                                        ? '/appointment-manager-doctor'
                                                        : '/appointment-manager'
                                                }
                                                className={`mr-4 text-base font-bold drop-shadow-lg ${
                                                    pathname === '/appointment-manager' ||
                                                    pathname === '/appointment-manager-doctor'
                                                        ? 'documentos-btn'
                                                        : 'citas-btn'
                                                }`}
                                            >
                                                Citas
                                            </Link>
                                            <Menu.Button>
                                                <figure className="border-4 border-sky-400	rounded-full w-16 h-16">
                                                    <img
                                                        className="h-full w-full rounded-full "
                                                        src={
                                                            user?.personalImage
                                                                ? `${APP_SERVER}/${user?.personalImage}`
                                                                : Configurations?.defaultImage
                                                        }
                                                        alt=""
                                                        onError={handleImageError}
                                                    />
                                                </figure>
                                            </Menu.Button>
                                        </div>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                    >
                                        <Menu.Items className="z-40 origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            {String(user.usertype) === '2' && (
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <Link
                                                            to="/doctor-profile"
                                                            className={classNames(
                                                                active ? 'bg-gray-100' : '',
                                                                'block px-4 py-2 text-sm text-gray-700'
                                                            )}
                                                        >
                                                            Perfil Doctor
                                                        </Link>
                                                    )}
                                                </Menu.Item>
                                            )}
                                            {String(user.usertype) === '2' && (
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <Link
                                                            to="/appointment-manager-doctor"
                                                            className={classNames(
                                                                active ? 'bg-gray-100' : '',
                                                                'block px-4 py-2 text-sm text-gray-700'
                                                            )}
                                                        >
                                                            Citas
                                                        </Link>
                                                    )}
                                                </Menu.Item>
                                            )}

                                            {String(user.usertype) === '1' && (
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <Link
                                                            to="/patient-profile"
                                                            className={classNames(
                                                                active ? 'bg-gray-100' : '',
                                                                'block px-4 py-2 text-sm text-gray-700'
                                                            )}
                                                        >
                                                            Perfil Paciente
                                                        </Link>
                                                    )}
                                                </Menu.Item>
                                            )}
                                            {String(user.usertype) === '1' && (
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <Link
                                                            to="/appointment-manager"
                                                            className={classNames(
                                                                active ? 'bg-gray-100' : '',
                                                                'block px-4 py-2 text-sm text-gray-700'
                                                            )}
                                                        >
                                                            Citas
                                                        </Link>
                                                    )}
                                                </Menu.Item>
                                            )}
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <span
                                                        onClick={() => setOpenDeleteAccountModal(true)}
                                                        className={classNames(
                                                            active ? 'bg-gray-100' : '',
                                                            'block px-4 py-2 text-sm text-gray-700'
                                                        )}
                                                    >
                                                        Eliminar cuenta
                                                    </span>
                                                )}
                                            </Menu.Item>
                                            <Menu.Item>
                                                {({ active }) => (
                                                    <span
                                                        onClick={() => setOpenSignOutModal(true)}
                                                        className={classNames(
                                                            active ? 'bg-gray-100' : '',
                                                            'block px-4 py-2 text-sm text-gray-700'
                                                        )}
                                                    >
                                                        Cerrar sesión
                                                    </span>
                                                )}
                                            </Menu.Item>
                                        </Menu.Items>
                                    </Transition>
                                </Menu>
                            </div>
                        )}
                        <RedAlert
                            open={Boolean(openSignOutModal)}
                            title={`Desea cerrar esta sesión?`}
                            bodyText={'Si confirma esta diálogo entonces pasará a cerrar la sesión que tiene abierta.'}
                            onConfirm={_confirmLogout}
                            onCancel={_confirmSignOutCancel}
                        />

                        {/* Delete Account Confirmation Modal */}
                        <DeleteConfirmationModal
                            open={openDeleteAccountModal}
                            onClose={_confirmDeleteAccountCancel}
                            title="Eliminar cuenta"
                            bodyText="¿Estás seguro de que quieres eliminar tu cuenta? Esta acción es irreversible y se perderán todos tus datos permanentemente."
                            onConfirm={handleDeleteAccount}
                            onCancel={_confirmDeleteAccountCancel}
                        />

                        {/* Delete Account Error Alert */}
                        {deleteAccountError && (
                            <RedAlert
                                open={Boolean(deleteAccountError)}
                                title="Error al eliminar cuenta"
                                bodyText={deleteAccountError}
                                onConfirm={() => setDeleteAccountError(null)}
                                onCancel={() => setDeleteAccountError(null)}
                            />
                        )}
                    </div>
                </div>
            </div>

            <Transition
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <Popover.Panel
                    focus
                    className="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right xl:hidden"
                >
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                        <div className="pt-5 pb-6 px-5 sm:pb-8">
                            <div className="flex items-center justify-between">
                                <div>
                                    <img className="h-8 w-auto" src={hLogo} alt="DoctoLink" />
                                </div>
                                <div className="-mr-2">
                                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-dl-primary-900">
                                        <span className="sr-only">Cerrar menú</span>
                                        <XIcon className="h-6 w-6" aria-hidden="true" />
                                    </Popover.Button>
                                </div>
                            </div>
                        </div>
                        <div className="py-6 px-5">
                            <div className="grid grid-cols-2 gap-4">
                                {/* <Link className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent" to={'/'}>
                  Inicio
                </Link> */}
                                <Link
                                    className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                    to={'/what-is-doctolink'}
                                >
                                    <Popover.Button> ¿Qué es Doctolink?</Popover.Button>
                                </Link>
                                <Link
                                    className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                    to={'/who-we-are'}
                                >
                                    <Popover.Button> ¿Quiénes somos?</Popover.Button>
                                </Link>
                                <Link
                                    to="/contact-us"
                                    className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                >
                                    <Popover.Button> Contacto </Popover.Button>
                                </Link>
                                <Link
                                    to="/blog"
                                    className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                >
                                    <Popover.Button> Blog </Popover.Button>
                                </Link>
                                {/* <Link
                                    to="/plans"
                                    className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                >
                                    <Popover.Button> Planes </Popover.Button>
                                </Link> */}

                                {user && (
                                    <>
                                        {/* Profile dropdown */}

                                        {String(user.usertype) === '2' && (
                                            <Link
                                                to="/doctor-profile"
                                                className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                            >
                                                <Popover.Button> Perfil Doctor</Popover.Button>
                                            </Link>
                                        )}
                                        {String(user.usertype) === '2' && (
                                            <Link
                                                to="/appointment-manager-doctor"
                                                className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                            >
                                                <Popover.Button> Citas</Popover.Button>
                                            </Link>
                                        )}

                                        {String(user.usertype) === '1' && (
                                            <Link
                                                to="/patient-profile"
                                                className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                            >
                                                <Popover.Button> Perfil Paciente </Popover.Button>
                                            </Link>
                                        )}
                                        {String(user.usertype) === '1' && (
                                            <Link
                                                to="/appointment-manager"
                                                className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent"
                                            >
                                                <Popover.Button> Citas </Popover.Button>
                                            </Link>
                                        )}
                                        <span
                                            onClick={() => setOpenSignOutModal(true)}
                                            className="rounded-md text-base font-medium text-gray-900 hover:text-dl-accent cursor-pointer"
                                        >
                                            Cerrar sesión
                                        </span>
                                    </>
                                )}
                            </div>

                            {!user && (
                                <div className="mt-6 flex flex-col gap-4">
                                    <Link
                                        to={'/sign-up'}
                                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700"
                                    >
                                        <Popover.Button>Registro Paciente</Popover.Button>
                                    </Link>
                                    <Link
                                        to={'/sign-up-doctor'}
                                        className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-full shadow-sm text-base font-medium text-white bg-dl-primary-900 hover:bg-dl-primary-700"
                                    >
                                        <Popover.Button>Registro Doctor</Popover.Button>
                                    </Link>
                                    <div className="flex flex-col gap-8 mt-6 text-center text-base font-medium text-dl-accent">
                                        &iquest;Ya tienes cuenta de DoctoLink?{' '}
                                        <Link className="text-dl-primary-900 hover:text-dl-primary-700" to="/sign-in">
                                            <Popover.Button>Iniciar sesión como paciente</Popover.Button>
                                        </Link>
                                        <Link
                                            className="text-dl-primary-900 hover:text-dl-primary-700"
                                            to="/sign-in-doctor"
                                        >
                                            <Popover.Button> Iniciar sesión como doctor</Popover.Button>
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Popover.Panel>
            </Transition>
        </Popover>
    );
}
